import React, { useState, useEffect, useRef } from 'react'
import { useTooltip, TooltipPopup } from '@reach/tooltip'
import cn from 'classnames'

interface TooltipProps {
  children: JSX.Element
  label: React.ReactNode
  className?: string
  zIndex?: number
}

export function Tooltip({ children, label, className, zIndex }: TooltipProps) {
  const targetRef = useRef<any>(null)
  const [visible, setVisible] = useState(false)
  const [trigger, tooltip] = useTooltip({
    onMouseDown: event => {
      event.stopPropagation()
      if (!targetRef.current) {
        targetRef.current = event.currentTarget
      }
      if (!visible) {
        setVisible(true)
      } else {
        setVisible(false)
      }
    },
    onMouseEnter: () => {
      // DESC: onMouseEnter can change visible state when on desktop screen
      if (window.innerWidth >= 1280) {
        setVisible(true)
      }
    },
    onMouseLeave: () => {
      setVisible(false)
    },
  })

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (targetRef.current && !targetRef.current.contains(event.target)) {
        setVisible(false)
      }
    }
    window.addEventListener('click', handleClickOutside)
    return () => {
      window.removeEventListener('click', handleClickOutside)
    }
  }, [targetRef])

  function position(triggerRec: any) {
    if (targetRef.current) {
      const { bottom, left } = targetRef.current.getBoundingClientRect()

      return {
        left: left + window.scrollX,
        top: bottom + window.scrollY,
      }
    }

    return {
      left: triggerRec.left + window.scrollX,
      top: triggerRec.bottom + window.scrollY,
    }
  }

  return (
    <>
      {React.cloneElement(children, trigger)}
      {/* <div
        className={cn(
          'absolute h-[10px] w-[10px] bg-primary-1 border border-blue z-10',
          {
            top: tooltip.triggerRect!.bottom + window.scrollY,
            left: tooltip.triggerRect!.left + window.scrollX,
            // hidden: !visible,
          }
        )}
      /> */}
      <TooltipPopup
        {...tooltip}
        className={className}
        isVisible={visible}
        label={label}
        style={{ zIndex: zIndex ?? 0 }}
        position={position}
      />
    </>
  )
}
